import { slice } from './slice';

export const { load, putAll, add, remove, update } = slice.actions;
